import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useApprovedEditAgreement() {
  const queryClient = useQueryClient()
  const token = useAccessToken()
  return useMutation({
    mutationFn: async (id_edit?: string) => {
      const response = await api.patch(`/agreement-edit/approve/${id_edit}`, null, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (!response.data) {
        throw new Error('Erro ao rejeitar as alteração de Minuta')
      }

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
